
<template>
  <div>
    <table style="width: 100%">
      <tr>
        <td style="width: 25%">
          <my-header></my-header>
        </td>
      </tr>

      <tr>
        <td colspan="3">
          <hr />
        </td>
      </tr>
      <!--<%--
      <tr>
        <td colspan="3">
          <h3></h3>
        </td>
      </tr>--%>-->
      <tr>
        <td colspan="3">
          <table style="width: 100%">
            <tr>
              <td style="width: 50%">
                <label style="font-weight: bold">Program:</label>
                {{test.ProgramName}}
              </td>
              <td style="width: 50%">
                <label style="font-weight: bold">Session:</label>
                {{test.Semester}}
              </td>
            </tr>

            <tr>
              <td style="width: 50%">
                <label style="font-weight: bold">Title:</label>
                {{test.Title}}
              </td>
              <td style="width: 50%">
                <label style="font-weight: bold">Type:</label>
                {{test.Type}}
              </td>
            </tr>
            <tr>
              <td style="width: 50%">
                <label style="font-weight: bold">Discription:</label>
                {{test.Discription}}
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr>
        <td colspan="3">

          <label>Student(s)</label>
          <table border="1" style="border-collapse: collapse">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Roll No</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Phone No</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in Students">
                <td align="center">{{ind+1}}</td>
                <td align="right">{{item.RollNo}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.FathersName}}</td>
                <td align="right">{{item.MobileNo}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>

      <tr>
        <td colspan="3">

          <label>Internal Supervisor(s)</label>
          <table border="1" style="border-collapse: collapse">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Emp Code</th>
                <th>Designation</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in Supervisors">
                <td align="center">{{ind+1}}</td>
                <td>{{item.Name}}</td>
                <td align="right">{{item.EmpCode}}</td>
                <td>{{item.Designation}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td colspan="3">

          <label>External Supervisor(s)</label>
          <table border="1" style="border-collapse: collapse">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Institute</th>
                <th>Designation</th>
                <th>Contact No</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in ExternalSupervisor">
                <td align="center">{{ind+1}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.Institute}}</td>
                <td>{{item.Designation}}</td>
                <td align="right">{{item.ContactNo}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        test: {},
        Students: [],
        Supervisors: [],
        ExternalSupervisor: [],
      }
    },
    created: function () {
      this.loadPrints();
    },
    methods: {
      loadPrints() {
        var vm = this;
        axios.post('/api/DCApi/loadFYPPrint')
          .then(function (response) {
            vm.test = response.data.lst;
            vm.Students = vm.test.Student;
            vm.Supervisors = vm.test.Teacher;
            vm.ExternalSupervisor = vm.test.External;
          })
      }
    }
  })
</script>
<style>
  table {
    width: 100% !important;
    font-size: 12px !important;
  }

  .custom {
    width: 100%;
    border-collapse: collapse;
  }

    .custom tbody tr td {
      padding-left: 2px;
    }

    .custom thead tr th {
      padding-left: 2px;
    }

  table thead tr th {
    background-color: lightgray;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/fypPrint.vue